import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { batchRequest, getRequest } from '../../../../../../api/ApiService';
import Auth from '../../../../../../routes/Auth';
import { handleSelectChange, arrayUniqueFilter } from '../../../utils';

import BannerLayout from '../../../layouts/banner';
import AbbreviatedMillionNumberFormat from "../../../../../../components/ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

import {
  FormulaName,
  FormulaValue
} from '../../../components/ui';

class EPSStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      averageSellingPrice: 0,
      unitCost: 0,
      grossMargin: 0,
      netIncome: 0,
      shares: 0,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(
      `${process.env.REACT_APP_API_URL}teams/`
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "EPS fail").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      batchRequest([
        `${process.env.REACT_APP_API_URL}team/report/metrics/?round_number=${activeRound}&team_id=${team_id}`,
        `${process.env.REACT_APP_API_URL}team/report/income_statement/?round_number=${activeRound}&team_id=${team_id}`,
      ])
        .then(res => {
          const metrics = res[0].body;
          const currentRoundMetrics = metrics.find(i => i.round_number === activeRound);
          const netRevenues = currentRoundMetrics ? Number(currentRoundMetrics['Net Revenues'] || 0) : 0;
          const unitsSold = currentRoundMetrics ? Number(currentRoundMetrics['Units Sold'] || 0) : 0;
          const averageSellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;
          const shares = currentRoundMetrics ? Number(currentRoundMetrics['Shares'] || 0) : 0;

          const incomeStatement = res[1].body;
          const currentRoundIncomeStatement = incomeStatement.find(i => i.round === roundId);
          const costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
          const unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;
          const netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;

          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
            averageSellingPrice,
            unitCost,
            netIncome: netIncome,
            shares,
          })
        })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      averageSellingPrice,
      unitCost,
      netIncome,
      shares,
    } = this.state;

    const { previousShownErrors, gamesTargets } = this.props;

    const grossMargin = Number(gamesTargets[0].gross_margin || 0);

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="EPS"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams did not generate enough profits`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p>The gross profit spread between your product’s average selling price <b>${averageSellingPrice.toFixed(2)}</b> and the average cost to manufacture each unit <b>${unitCost.toFixed(2)}</b> was ${Number((netIncome / 1000000).toFixed(2))}, which was not enough to generate the gross profit margin needed to hit the <b>{Number((grossMargin * 100).toFixed(2))}%</b> gross margin target.</p>
            <p><strong>Common reasons why teams are unable to maximize profits:</strong></p>
            <p><strong>Revenue Challenges:</strong> A mix of marketing mix and/or capacity challenges might have led to lower revenues (e.g. lower ranking products, less productive machines).</p>
            <p><strong>Operating Margin Challenges:</strong> There’s likely margin compression since selling prices do not change, but costs are likely rising from round to round as teams upgrade their products to be more competitive. Those who updgraded their products.</p>
            <p><strong>High Financing Costs:</strong> Some teams took on a lot of debt in the earlier rounds and are unable to repay. They are feeling the impact now as a result of the metrics shifting to profit driven metrics.</p>
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <FormulaName background="#2DA548">
              Earnings Per Share<br />
              (EPS)
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Net Profits
              <span className='divider' />
              Average Total Shares
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              <AbbreviatedMillionNumberFormat
                value={netIncome}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
              <span className='divider' />
              <AbbreviatedMillionNumberFormat
                value={shares}
                negativeClass="negative-value"
                floatCount={2}
              />
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#D5D9DD',
          background: 'rgba(45, 165, 72, 0.12)',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default EPSStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/eps/step2.js